import { all } from 'redux-saga/effects';
import avatarSagas from './avatarSagas';

export default function* rootSaga() {
  yield all([avatarSagas]);
}
